import React from 'react';
import Field from './Field'

export default class FieldDisguisedRadioList extends Field {
    constructor(props) {
        super(props)

        this.state = {
            selectedOption: props.value
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            selectedOption: nextProps.value
        })
    }

    onOptionChange = item => {
        let v = item.value;
        if (this.state.selectedOption === v) {
            let idx = this.props.items.map(x => x.value).indexOf(v);
            if (idx > 0)
                v = this.props.items[idx - 1].value
        }
        this.setState({
            selectedOption: v
        })

        if (this.props.onChange) {
            this.props.onChange(v)
        }
    }

    isOptionChecked = item => {
        let myIdx = this.props.items.map(x => x.value).indexOf(item.value);
        let selectedIdx = this.props.items.map(x => x.value).indexOf(this.state.selectedOption);
        return myIdx <= selectedIdx && !item.disabled;
    }

    renderField() {
        return (
            <div className="configuration-radiogroup">
                {this.props.items.map(item => (
                    this.renderItem(item)
                ))}
            </div>
        )
    }

    renderItem(item) {
        let itemId = this.generateUniqueId();
        let disabled = this.props.disabled || item.disabled;

        return (
            <div key={item.value} className="configuration-radiogroup-item">
                <input id={itemId} type="checkbox" checked={this.isOptionChecked(item)} disabled={disabled}
                       onChange={e => this.onOptionChange(item)}/>
                <label tabIndex="0" htmlFor={itemId}>{__(item.text)}</label>
            </div>
        )
    }
}